<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 17:27:53
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-01-29 16:59:50
 * @name: 通讯录
 * @Description: 通讯录
 * @FilePath: \preSaleNafterSaleBackstage\src\views\mailList\mailList.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <layout-normal class="mailList">
    <tree-list :mailList="mailList"></tree-list>
    <Content :mailList="mailList"></Content>
  </layout-normal>
</template>
<script>
import treeList from "@/components/mailList/tree-list.vue";
import Content from "@/components/mailList/Content.vue";
import mailList from "@/object/mailList/mailList.class.js";

export default {
  name: "mailList",
  components: {
    treeList,
    Content,
  },
  data() {
    return {
      mailList: new mailList(),
    };
  },
};
</script>
<style lang="scss" scoped>
.mailList {
  /deep/ .layout-card {
    align-items: stretch;
    .layout-content {
      @extend .extend-flex-normal;
      flex: 1;
      padding: 0;
      align-items: stretch;
    }
  }
}
</style>